module.exports = __webpack_public_path__ + "img/language-solid.e6cc7dca.svg";